import { render, staticRenderFns } from "./OrderHoldReason.vue?vue&type=template&id=1897c7d2&"
import script from "./OrderHoldReason.vue?vue&type=script&lang=ts&"
export * from "./OrderHoldReason.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports